import { getStorageTankList, createStorageTank } from '@/api/storageTank'
import Vue from 'vue'

const state = {
    storageTankList: [],
    totalCounts: 0
}

const actions = {
    async getStorageTankListAction({ commit }, payload) {
        try {
            const storageTankList = await getStorageTankList(payload);
            commit('SETSTORAGETANKLIST', storageTankList.data)
        } catch (error) {
            throw error.message
        }
    },
    async getTankRentalByIDAction({ commit }, payload) {
        try {
            const tankRental = await getTankRentalByID(payload)
            return tankRental.data
        } catch (error) {
            throw error.message
        }
    },
    async createStorageTankAction({ commit }, payload) {
        try {
            const storageTank = await createStorageTank(payload);
            commit('ADD_STORAGETANK', storageTank.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateTankRentalAction({ commit }, payload) {
        try {
            const tankRental = await updateTankRental(payload.id, payload.data)
            commit('UPDATETANKRENTAL', tankRental.data)
        } catch (error) {
            throw error.message
        }
    },
    async deleteTankRentalAction({ commit }, payload) {
        try {
            await deleteTankRental(payload)
            commit('DELETETANKRENTAL', payload)
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETSTORAGETANKLIST(state, payload) {
        state.storageTankList = payload.storageTankList;
        state.totalCounts = payload.totalCounts
    },
    ADD_STORAGETANK(state, storageTank) {
        state.storageTankList.unshift(storageTank)
        state.totalCounts++
    },
    DELETETANKRENTAL(state, id) {
        state.storageTankList = state.storageTankList.filter(e => e._id !== id)
        state.totalCounts--
    },
    UPDATETANKRENTAL(state, tankRental) {
        Vue.set(state.storageTankList, state.storageTankList.findIndex(x => x._id === tankRental._id), tankRental)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}